export const REQUEST_ID_HEADER = 'X-Request-Id';
export const REQUEST_ID_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;

export function isValidRequestId(value: unknown): value is string {
  return typeof value === 'string' && REQUEST_ID_PATTERN.test(value);
}

export function newRequestId(): string {
  return crypto.randomUUID();
}

export function resolveRequestId(inbound: string | null | undefined): string {
  if (inbound && isValidRequestId(inbound)) return inbound;
  return newRequestId();
}
